// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/agents/agents.actions.go

import { type Scope } from "~/hooks/useScope";
import { LIST_REGISTRATION_TOKENS } from "./action";

export function canListRegistrationTokens(scope: Scope): boolean {
  return scope.iamActions.includes(LIST_REGISTRATION_TOKENS);
}
